//import React from 'react';
//import ReactDOM from 'react-dom/client';
//import MainPage from './pages/MainPage';
//import store from './app/store';
//import { Provider } from 'react-redux';
//import * as serviceWorker from './serviceWorker';
//import "@blueprintjs/core/lib/css/blueprint.css";
//import "@blueprintjs/icons/lib/css/blueprint-icons.css";

//const rootElement = document.getElementById('root');
//const root = ReactDOM.createRoot(rootElement);

//root.render(
//    <React.StrictMode>
//        <Provider store={store}>
//            <MainPage />
//        </Provider>
//    </React.StrictMode>
//);

//// If you want your app to work offline and load faster, you can change
//// unregister() to register() below. Note this comes with some pitfalls.
//// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
import React from 'react';
import ReactDOM from 'react-dom';
import MainPage from './pages/MainPage';
import store from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            {/*<Main />*/}
            <MainPage />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

